export const googleMapMetaData = {
    isRepeatable: false
}
